<template>
  <div>
    <!-- Cabeçalho Principal -->
    <b-row class="mb-2">
      <b-col>
        <b-card class="header-marcar_consulta bg-gradient-primary">
          <b-row align-v="center">
            <b-col lg="5" md="12">
              <h1 class="text-white mb-50">
                <feather-icon icon="FileTextIcon" size="28" class="mr-50" />
                Questionários Sociodemográficos
              </h1>
              <p class="text-white-50 mb-0 font-small-3">
                Listagem de alunos que responderam o questionário socioeconômico e ambiental
              </p>
            </b-col>
            <b-col lg="5" md="8" class="mt-1 mt-lg-0">
              <b-form @submit.prevent="fetchQuestionarios">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="filtro.search"
                    placeholder="Buscar por aluno, responsável, bairro, cidade..."
                    @input="onSearchInput"
                  />
                </b-input-group>
              </b-form>
            </b-col>
            <b-col lg="2" md="4" class="text-lg-right mt-1 mt-lg-0">
              <b-button variant="success" class="btn-block" @click="exportarCsv" :disabled="!fetchedData.totalItems">
                <feather-icon icon="DownloadIcon" class="mr-50" />
                Exportar CSV
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- Cards de Estatísticas Rápidas -->
    <b-row class="mb-2">
      <b-col sm="6" lg="3">
        <b-card no-body class="p-1 mb-0 border-left-primary shadow-none">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h3 class="mb-25 font-weight-bolder text-primary">
                {{ fetchedData.totalItems || 0 }}
              </h3>
              <span class="text-muted font-small-3">Total Respondidos</span>
            </div>
            <div class="avatar bg-light-primary p-50 m-0">
              <feather-icon icon="UsersIcon" size="24" class="text-primary" />
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="p-1 mb-0 border-left-info shadow-none">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h3 class="mb-25 font-weight-bolder text-info">
                {{ totalEscolasRepresentadas }}
              </h3>
              <span class="text-muted font-small-3">Escolas na Página</span>
            </div>
            <div class="avatar bg-light-info p-50 m-0">
              <feather-icon icon="BookOpenIcon" size="24" class="text-info" />
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="p-1 mb-0 border-left-danger shadow-none">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h3 class="mb-25 font-weight-bolder text-danger">
                {{ totalComHistoricoDengue }}
              </h3>
              <span class="text-muted font-small-3">Relataram Dengue</span>
            </div>
            <div class="avatar bg-light-danger p-50 m-0">
              <feather-icon icon="ActivityIcon" size="24" class="text-danger" />
            </div>
          </div>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="p-1 mb-0 border-left-success shadow-none">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h3 class="mb-25 font-weight-bolder text-success">
                {{ fetchedData.currentPage || 1 }} / {{ fetchedData.totalPages || 1 }}
              </h3>
              <span class="text-muted font-small-3">Página Atual</span>
            </div>
            <div class="avatar bg-light-success p-50 m-0">
              <feather-icon icon="CheckCircleIcon" size="24" class="text-success" />
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Filtros Secundários: Escola e Turma -->
    <b-card class="mb-2">
      <b-row>
        <b-col md="4" class="mb-1 mb-md-0">
          <label class="font-small-3 font-weight-bold">Escola</label>
          <v-select
            v-model="filtro.schoolId"
            :options="escolaOptions"
            :reduce="option => option.value"
            label="text"
            placeholder="Todas as escolas"
            @input="onEscolaChange"
          />
        </b-col>
        <b-col md="4" class="mb-1 mb-md-0">
          <label class="font-small-3 font-weight-bold">Turma</label>
          <v-select
            v-model="filtro.classroomId"
            :options="turmaOptions"
            :reduce="option => option.value"
            label="text"
            placeholder="Todas as turmas"
            :disabled="!filtro.schoolId"
            @input="fetchQuestionarios"
          />
        </b-col>
        <b-col md="4" class="d-flex align-items-end">
          <b-button variant="outline-secondary" class="mr-1" @click="limparFiltros">
            Limpar Filtros
          </b-button>
          <b-button variant="primary" @click="fetchQuestionarios">
            Filtrar
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <!-- Barra de Total e Paginação Superior -->
    <div class="d-flex align-items-center justify-content-between mb-1" v-if="fetchedData.totalItems">
      <div class="text-muted font-small-3">
        Mostrando <strong>{{ (fetchedData.content || []).length }}</strong> de <strong>{{ fetchedData.totalItems }}</strong> questionário(s) preenchido(s)
      </div>
      <b-pagination
        v-model="filtro.page"
        :total-rows="fetchedData.totalItems"
        :per-page="filtro.itemsPerPage"
        class="mb-0"
        @input="fetchQuestionarios"
      />
    </div>

    <!-- Tabela Principal -->
    <b-card no-body>
      <b-table
        ref="refTable"
        class="position-relative"
        :items="fetchedData.content"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="Nenhum questionário encontrado."
      >
        <!-- Coluna Aluno -->
        <template #cell(nomeCompleto)="data">
          <div>
            <span class="font-weight-bold d-block text-primary">
              {{ data.item.nomeCompleto || 'Aluno Não Identificado' }}
            </span>
            <small class="text-muted" v-if="data.item.email">
              <feather-icon icon="MailIcon" size="12" class="mr-25" />
              {{ data.item.email }}
            </small>
            <small class="text-muted ml-50" v-if="data.item.telefone">
              <feather-icon icon="PhoneIcon" size="12" class="mr-25" />
              {{ data.item.telefone }}
            </small>
          </div>
        </template>

        <!-- Coluna Escola -->
        <template #cell(escola)="data">
          <div>
            <span class="font-weight-bold">{{ data.item.escola || '-' }}</span>
          </div>
        </template>

        <!-- Coluna Turma / Turno -->
        <template #cell(turma)="data">
          <div>
            <b-badge variant="light-primary" class="font-small-2">
              {{ data.item.turma || data.item.serie || 'Geral' }}
            </b-badge>
            <div class="text-muted font-small-2 mt-25" v-if="data.item.turno">
              Turno: {{ data.item.turno }}
            </div>
          </div>
        </template>

        <!-- Coluna Responsável -->
        <template #cell(nomeResponsavel)="data">
          <div>
            <span class="d-block font-weight-bold text-dark">
              {{ data.item.nomeResponsavel || '-' }}
            </span>
            <small class="text-muted" v-if="data.item.grauParentesco">
              Parentesco: {{ data.item.grauParentesco }}
            </small>
            <div class="font-small-2 text-muted" v-if="data.item.telefoneResponsavel">
              <feather-icon icon="PhoneCallIcon" size="12" class="mr-25" />
              {{ data.item.telefoneResponsavel }}
            </div>
          </div>
        </template>

        <!-- Coluna Localização -->
        <template #cell(localizacao)="data">
          <div>
            <span class="font-small-3 font-weight-bold">
              {{ data.item.bairro || '-' }}
            </span>
            <small class="text-muted d-block" v-if="data.item.cidade">
              {{ data.item.cidade }}
            </small>
            <small class="text-muted" v-if="data.item.cep">
              CEP: {{ data.item.cep }}
            </small>
          </div>
        </template>

        <!-- Coluna Histórico Saúde -->
        <template #cell(historicoSaude)="data">
          <div>
            <b-badge
              v-if="data.item.teveDengue === 'Sim' || data.item.teveDengue === 'true'"
              variant="light-danger"
              class="mr-25 mb-25"
            >
              Dengue
            </b-badge>
            <b-badge
              v-if="data.item.teveChikungunya === 'Sim' || data.item.teveChikungunya === 'true'"
              variant="light-warning"
              class="mr-25 mb-25"
            >
              Chikungunya
            </b-badge>
            <b-badge
              v-if="data.item.teveZikaVirus === 'Sim' || data.item.teveZikaVirus === 'true'"
              variant="light-info"
              class="mr-25 mb-25"
            >
              Zika
            </b-badge>
            <span
              v-if="
                data.item.teveDengue !== 'Sim' &&
                data.item.teveDengue !== 'true' &&
                data.item.teveChikungunya !== 'Sim' &&
                data.item.teveChikungunya !== 'true' &&
                data.item.teveZikaVirus !== 'Sim' &&
                data.item.teveZikaVirus !== 'true'
              "
              class="text-muted font-small-2"
            >
              Nenhum relato
            </span>
          </div>
        </template>

        <!-- Coluna Data de Envio -->
        <template #cell(createdAt)="data">
          <small class="text-muted">
            <feather-icon icon="CalendarIcon" size="12" class="mr-25" />
            {{ formatarData(data.item.createdAt) }}
          </small>
        </template>

        <!-- Coluna Ações -->
        <template #cell(actions)="data">
          <b-button
            variant="outline-primary"
            size="sm"
            @click="abrirDetalhes(data.item.id)"
            v-b-tooltip.hover
            title="Visualizar Respostas Completas"
          >
            <feather-icon icon="EyeIcon" class="mr-25" />
            Ver Respostas
          </b-button>
        </template>
      </b-table>
    </b-card>

    <!-- Paginação Inferior -->
    <div class="d-flex justify-content-end mt-1" v-if="fetchedData.totalItems">
      <b-pagination
        v-model="filtro.page"
        :total-rows="fetchedData.totalItems"
        :per-page="filtro.itemsPerPage"
        class="mb-0"
        @input="fetchQuestionarios"
      />
    </div>

    <!-- Modal com Respostas Detalhadas do Questionário -->
    <b-modal
      id="modal-detalhes-questionario"
      v-model="modalDetalhesAberto"
      title="Questionário Sociodemográfico - Respostas Detalhadas"
      title-class="font-medium-3 text-primary font-weight-bolder"
      size="xl"
      ok-only
      ok-title="Fechar"
      ok-variant="secondary"
      scrollable
    >
      <div v-if="isLoadingDetalhes" class="text-center py-4">
        <b-spinner variant="primary" label="Carregando respostas..." />
        <p class="mt-1 text-muted">Carregando dados completos do questionário...</p>
      </div>

      <div v-else-if="detalhes">
        <b-tabs pills class="nav-horizontal">
          <!-- Aba 1: Dados do Aluno -->
          <b-tab title="Aluno e Escola" active>
            <div class="pt-1">
              <h5 class="text-primary mb-1">
                <feather-icon icon="UserIcon" class="mr-50" />
                Dados do Aluno
              </h5>
              <b-row class="mb-2">
                <b-col md="6" class="mb-1">
                  <strong>Nome Completo:</strong>
                  <div>{{ detalhes.nomeCompleto || '-' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>Data de Nascimento:</strong>
                  <div>{{ detalhes.dataNascimento || '-' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>Idade:</strong>
                  <div>{{ detalhes.idade ? `${detalhes.idade} anos` : '-' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>Sexo:</strong>
                  <div>{{ detalhes.sexo || detalhes.outroSexo || '-' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>Raça / Cor:</strong>
                  <div>{{ detalhes.raca || detalhes.outraRaca || '-' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>CPF:</strong>
                  <div>{{ detalhes.cpf || '-' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>RG:</strong>
                  <div>{{ detalhes.rg || '-' }}</div>
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Telefone / WhatsApp:</strong>
                  <div>{{ detalhes.telefone || '-' }}</div>
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>E-mail:</strong>
                  <div>{{ detalhes.email || '-' }}</div>
                </b-col>
              </b-row>

              <hr />
              <h5 class="text-primary mb-1">
                <feather-icon icon="BookOpenIcon" class="mr-50" />
                Dados Escolares
              </h5>
              <b-row>
                <b-col md="6" class="mb-1">
                  <strong>Escola:</strong>
                  <div>{{ detalhes.escola || '-' }}</div>
                </b-col>
                <b-col md="2" class="mb-1">
                  <strong>Turma:</strong>
                  <div>{{ detalhes.turma || '-' }}</div>
                </b-col>
                <b-col md="2" class="mb-1">
                  <strong>Série / Ano:</strong>
                  <div>{{ detalhes.serie || '-' }}</div>
                </b-col>
                <b-col md="2" class="mb-1">
                  <strong>Turno:</strong>
                  <div>{{ detalhes.turno || '-' }}</div>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <!-- Aba 2: Responsável e Endereço -->
          <b-tab title="Responsável e Endereço">
            <div class="pt-1">
              <h5 class="text-primary mb-1">
                <feather-icon icon="UserCheckIcon" class="mr-50" />
                Dados do Responsável
              </h5>
              <b-row class="mb-2">
                <b-col md="6" class="mb-1">
                  <strong>Nome do Responsável:</strong>
                  <div>{{ detalhes.nomeResponsavel || '-' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>Grau de Parentesco:</strong>
                  <div>{{ detalhes.grauParentesco || '-' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>Nível de Instrução:</strong>
                  <div>{{ detalhes.nivelInstrucao || '-' }}</div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Telefone do Responsável:</strong>
                  <div>{{ detalhes.telefoneResponsavel || '-' }}</div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Endereço do Responsável:</strong>
                  <div>{{ detalhes.enderecoResponsavel || '-' }}</div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Bairro / Cidade:</strong>
                  <div>{{ detalhes.bairroResponsavel || '-' }} - {{ detalhes.cidadeResponsavel || '-' }}</div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>CEP do Responsável:</strong>
                  <div>{{ detalhes.cepResponsavel || 'Não informado (opcional)' }}</div>
                </b-col>
              </b-row>

              <hr />
              <h5 class="text-primary mb-1">
                <feather-icon icon="MapPinIcon" class="mr-50" />
                Endereço do Aluno
              </h5>
              <b-row>
                <b-col md="6" class="mb-1">
                  <strong>Logradouro / Endereço Atual:</strong>
                  <div>{{ detalhes.enderecoAtual || '-' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>Bairro:</strong>
                  <div>{{ detalhes.bairro || '-' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>Cidade:</strong>
                  <div>{{ detalhes.cidade || '-' }}</div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>CEP do Aluno:</strong>
                  <div>{{ detalhes.cep || 'Não informado' }}</div>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <!-- Aba 3: Moradia -->
          <b-tab title="Moradia e Família">
            <div class="pt-1">
              <h5 class="text-primary mb-1">
                <feather-icon icon="HomeIcon" class="mr-50" />
                Estrutura e Habitação
              </h5>
              <b-row>
                <b-col md="4" class="mb-1">
                  <strong>Condição de Moradia:</strong>
                  <div>{{ detalhes.condicaoMoradia || detalhes.outraCondicaoMoradia || '-' }}</div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Tipo de Moradia:</strong>
                  <div>{{ detalhes.tipoMoradia || '-' }}</div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Tipo de Residência:</strong>
                  <div>{{ detalhes.tipoResidencia || detalhes.outroTipoResidencia || '-' }}</div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Localização:</strong>
                  <div>{{ detalhes.localizacaoMoradia || '-' }}</div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Quantidade de Cômodos:</strong>
                  <div>{{ detalhes.quantidadeComodos || '-' }}</div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Pessoas que moram na casa:</strong>
                  <div>{{ detalhes.quantidadePessoasMoram || '-' }}</div>
                </b-col>
                <b-col md="12" class="mb-1">
                  <strong>Quem mora na residência:</strong>
                  <div>{{ detalhes.moradores || '-' }}</div>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <!-- Aba 4: Bens e Saneamento -->
          <b-tab title="Bens e Saneamento">
            <div class="pt-1">
              <h5 class="text-primary mb-1">
                <feather-icon icon="DropletIcon" class="mr-50" />
                Água e Saneamento
              </h5>
              <b-row class="mb-2">
                <b-col md="6" class="mb-1">
                  <strong>Tipo de Abastecimento de Água:</strong>
                  <div>{{ detalhes.tipoAbastecimentoAgua || detalhes.outroAbastecimentoAgua || '-' }}</div>
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Forma de Armazenamento de Água:</strong>
                  <div>{{ detalhes.armazenaAgua || '-' }}</div>
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Renda Familiar:</strong>
                  <div>{{ detalhes.rendaFamiliar || '-' }}</div>
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Benefício Social:</strong>
                  <div>{{ detalhes.beneficioSocial || detalhes.outroBeneficioSocial || 'Nenhum' }}</div>
                </b-col>
              </b-row>

              <hr />
              <h5 class="text-primary mb-1">
                <feather-icon icon="CheckSquareIcon" class="mr-50" />
                Bens e Eletrodomésticos
              </h5>
              <b-row>
                <b-col sm="6" md="4" class="mb-50">
                  <feather-icon :icon="detalhes.possuiEnergiaEletrica === 'Sim' || detalhes.possuiEnergiaEletrica === 'true' ? 'Check' : 'X'" :class="detalhes.possuiEnergiaEletrica === 'Sim' || detalhes.possuiEnergiaEletrica === 'true' ? 'text-success mr-50' : 'text-danger mr-50'" />
                  Energia Elétrica
                </b-col>
                <b-col sm="6" md="4" class="mb-50">
                  <feather-icon :icon="detalhes.possuiInternet === 'Sim' || detalhes.possuiInternet === 'true' ? 'Check' : 'X'" :class="detalhes.possuiInternet === 'Sim' || detalhes.possuiInternet === 'true' ? 'text-success mr-50' : 'text-danger mr-50'" />
                  Internet
                </b-col>
                <b-col sm="6" md="4" class="mb-50">
                  <feather-icon :icon="detalhes.possuiComputador === 'Sim' || detalhes.possuiComputador === 'true' ? 'Check' : 'X'" :class="detalhes.possuiComputador === 'Sim' || detalhes.possuiComputador === 'true' ? 'text-success mr-50' : 'text-danger mr-50'" />
                  Computador
                </b-col>
                <b-col sm="6" md="4" class="mb-50">
                  <feather-icon :icon="detalhes.possuiGeladeira === 'Sim' || detalhes.possuiGeladeira === 'true' ? 'Check' : 'X'" :class="detalhes.possuiGeladeira === 'Sim' || detalhes.possuiGeladeira === 'true' ? 'text-success mr-50' : 'text-danger mr-50'" />
                  Geladeira
                </b-col>
                <b-col sm="6" md="4" class="mb-50">
                  <feather-icon :icon="detalhes.possuiVentilador === 'Sim' || detalhes.possuiVentilador === 'true' ? 'Check' : 'X'" :class="detalhes.possuiVentilador === 'Sim' || detalhes.possuiVentilador === 'true' ? 'text-success mr-50' : 'text-danger mr-50'" />
                  Ventilador
                </b-col>
                <b-col sm="6" md="4" class="mb-50">
                  <feather-icon :icon="detalhes.possuiLavadoraRoupa === 'Sim' || detalhes.possuiLavadoraRoupa === 'true' ? 'Check' : 'X'" :class="detalhes.possuiLavadoraRoupa === 'Sim' || detalhes.possuiLavadoraRoupa === 'true' ? 'text-success mr-50' : 'text-danger mr-50'" />
                  Lavadora de Roupa
                </b-col>
                <b-col sm="6" md="4" class="mb-50">
                  <feather-icon :icon="detalhes.possuiTelevisao === 'Sim' || detalhes.possuiTelevisao === 'true' ? 'Check' : 'X'" :class="detalhes.possuiTelevisao === 'Sim' || detalhes.possuiTelevisao === 'true' ? 'text-success mr-50' : 'text-danger mr-50'" />
                  Televisão
                </b-col>
                <b-col sm="6" md="4" class="mb-50">
                  <feather-icon :icon="detalhes.possuiTelefone === 'Sim' || detalhes.possuiTelefone === 'true' ? 'Check' : 'X'" :class="detalhes.possuiTelefone === 'Sim' || detalhes.possuiTelefone === 'true' ? 'text-success mr-50' : 'text-danger mr-50'" />
                  Telefone / Celular
                </b-col>
                <b-col sm="6" md="4" class="mb-50">
                  <feather-icon :icon="detalhes.possuiRadio === 'Sim' || detalhes.possuiRadio === 'true' ? 'Check' : 'X'" :class="detalhes.possuiRadio === 'Sim' || detalhes.possuiRadio === 'true' ? 'text-success mr-50' : 'text-danger mr-50'" />
                  Rádio
                </b-col>
                <b-col sm="6" md="4" class="mb-50">
                  <feather-icon :icon="detalhes.possuiAutomovel === 'Sim' || detalhes.possuiAutomovel === 'true' ? 'Check' : 'X'" :class="detalhes.possuiAutomovel === 'Sim' || detalhes.possuiAutomovel === 'true' ? 'text-success mr-50' : 'text-danger mr-50'" />
                  Automóvel
                </b-col>
                <b-col sm="6" md="4" class="mb-50">
                  <feather-icon :icon="detalhes.possuiMoto === 'Sim' || detalhes.possuiMoto === 'true' ? 'Check' : 'X'" :class="detalhes.possuiMoto === 'Sim' || detalhes.possuiMoto === 'true' ? 'text-success mr-50' : 'text-danger mr-50'" />
                  Motocicleta
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <!-- Aba 5: Arboviroses e Prevenção -->
          <b-tab title="Arboviroses e Prevenção">
            <div class="pt-1">
              <h5 class="text-primary mb-1">
                <feather-icon icon="ActivityIcon" class="mr-50" />
                Histórico Pessoal de Arboviroses
              </h5>
              <b-row class="mb-2">
                <b-col md="4" class="mb-1">
                  <strong>Teve Dengue:</strong>
                  <div>
                    <b-badge :variant="detalhes.teveDengue === 'Sim' || detalhes.teveDengue === 'true' ? 'danger' : 'secondary'">
                      {{ detalhes.teveDengue || 'Não' }}
                    </b-badge>
                  </div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Dengue Hemorrágica:</strong>
                  <div>
                    <b-badge :variant="detalhes.teveDengueHemorragica === 'Sim' || detalhes.teveDengueHemorragica === 'true' ? 'danger' : 'secondary'">
                      {{ detalhes.teveDengueHemorragica || 'Não' }}
                    </b-badge>
                  </div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Chikungunya:</strong>
                  <div>
                    <b-badge :variant="detalhes.teveChikungunya === 'Sim' || detalhes.teveChikungunya === 'true' ? 'warning' : 'secondary'">
                      {{ detalhes.teveChikungunya || 'Não' }}
                    </b-badge>
                  </div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Zika Vírus:</strong>
                  <div>
                    <b-badge :variant="detalhes.teveZikaVirus === 'Sim' || detalhes.teveZikaVirus === 'true' ? 'info' : 'secondary'">
                      {{ detalhes.teveZikaVirus || 'Não' }}
                    </b-badge>
                  </div>
                </b-col>
                <b-col md="4" class="mb-1">
                  <strong>Febre Amarela:</strong>
                  <div>
                    <b-badge :variant="detalhes.teveFebreAmarela === 'Sim' || detalhes.teveFebreAmarela === 'true' ? 'warning' : 'secondary'">
                      {{ detalhes.teveFebreAmarela || 'Não' }}
                    </b-badge>
                  </div>
                </b-col>
              </b-row>

              <hr />
              <h5 class="text-primary mb-1">
                <feather-icon icon="UsersIcon" class="mr-50" />
                Histórico Familiar (Alguém em casa teve)
              </h5>
              <b-row class="mb-2">
                <b-col md="3" class="mb-1">
                  <strong>Dengue em Casa:</strong>
                  <div>{{ detalhes.alguemCasaTeveDengue || 'Não' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>Chikungunya em Casa:</strong>
                  <div>{{ detalhes.alguemCasaTeveChikungunya || 'Não' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>Zika em Casa:</strong>
                  <div>{{ detalhes.alguemCasaTeveZikaVirus || 'Não' }}</div>
                </b-col>
                <b-col md="3" class="mb-1">
                  <strong>Febre Amarela em Casa:</strong>
                  <div>{{ detalhes.alguemCasaTeveFebreAmarela || 'Não' }}</div>
                </b-col>
              </b-row>

              <hr />
              <h5 class="text-primary mb-1">
                <feather-icon icon="ShieldIcon" class="mr-50" />
                Cuidados e Prevenção
              </h5>
              <b-row>
                <b-col md="6" class="mb-1">
                  <strong>Usa proteção contra mosquitos:</strong>
                  <div>{{ detalhes.usaProtecaoMosquitos || '-' }}</div>
                  <small class="text-muted" v-if="detalhes.formaProtecaoMosquitos">
                    Formas: {{ detalhes.formaProtecaoMosquitos }}
                  </small>
                </b-col>
                <b-col md="6" class="mb-1">
                  <strong>Práticas de prevenção na residência:</strong>
                  <div>{{ detalhes.casaPrevencaoMosquitos || '-' }}</div>
                  <small class="text-muted" v-if="detalhes.formaCasaPrevencaoMosquitos">
                    Ações: {{ detalhes.formaCasaPrevencaoMosquitos }}
                  </small>
                </b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>

<script>
import usersService from '@/services/usersService'
import questionarioSocioService from '@/services/questionarioSocioService'
import schoolService from '@/services/schoolService'
import classroomService from '@/services/classroomService'
import { hideSpinner, showSpinner } from '@/services/spinService'
import moment from 'moment'
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BPagination,
  BTable,
  BBadge,
  BSpinner,
  BModal,
  BTabs,
  BTab,
  VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'QuestionarioSocioLista',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BPagination,
    BTable,
    BBadge,
    BSpinner,
    BModal,
    BTabs,
    BTab,
    vSelect,
  },
  data() {
    return {
      filtro: {
        page: 1,
        itemsPerPage: 10,
        search: '',
        schoolId: null,
        classroomId: null,
        professorId: null,
      },
      searchTimeout: null,
      escolaOptions: [],
      turmaOptions: [],
      professorTurmas: [],
      fetchedData: {
        content: [],
        totalItems: 0,
        totalPages: 0,
        currentPage: 1,
      },
      tableColumns: [
        { key: 'nomeCompleto', label: 'Aluno', sortable: false },
        { key: 'escola', label: 'Escola', sortable: false },
        { key: 'turma', label: 'Turma', sortable: false },
        { key: 'nomeResponsavel', label: 'Responsável', sortable: false },
        { key: 'localizacao', label: 'Bairro / Cidade', sortable: false },
        { key: 'historicoSaude', label: 'Arboviroses', sortable: false },
        { key: 'createdAt', label: 'Respondido em', sortable: false },
        { key: 'actions', label: 'Ações', sortable: false, tdClass: 'text-center', thClass: 'text-center' },
      ],
      modalDetalhesAberto: false,
      isLoadingDetalhes: false,
      detalhes: null,
    }
  },
  computed: {
    totalEscolasRepresentadas() {
      const setEscolas = new Set()
      ;(this.fetchedData.content || []).forEach(item => {
        if (item.escola) setEscolas.add(item.escola)
      })
      return setEscolas.size
    },
    totalComHistoricoDengue() {
      return (this.fetchedData.content || []).filter(
        item => item.teveDengue === 'Sim' || item.teveDengue === 'true'
      ).length
    },
  },
  mounted() {
    this.carregarEscolas()
    this.fetchQuestionarios()
  },
  methods: {
    async carregarEscolas() {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      const isProfessor = userData?.role === 'Professor' || userData?.role === 3

      if (isProfessor && userData?.id) {
        this.filtro.professorId = userData.id
        try {
          const profData = await usersService.getProfessorTurmas(userData.id)
          const turmas = profData?.turmas || []
          this.professorTurmas = turmas
          const escolasMap = new Map()

          turmas.forEach(t => {
            const id = t.escolaId || t.schoolId
            const name = t.escola || t.schoolName
            if (id && name && !escolasMap.has(id)) {
              escolasMap.set(id, { value: id, text: name })
            }
          })

          if (escolasMap.size === 0 && userData.schoolId) {
            escolasMap.set(userData.schoolId, {
              value: userData.schoolId,
              text: userData.school?.name || 'Minha Escola',
            })
          }

          this.escolaOptions = Array.from(escolasMap.values())
        } catch (error) {
          console.error('Erro ao carregar escolas do professor:', error)
          this.escolaOptions = []
        }
      } else {
        try {
          const res = await schoolService.getAll({ page: 1, itemsPerPage: 1000 })
          const list = res.content || res || []
          this.escolaOptions = list
            .map(e => ({ value: e.id, text: e.name }))
            .sort((a, b) => (a.text || '').localeCompare(b.text || '', 'pt-BR'))
        } catch (error) {
          console.error('Erro ao carregar escolas:', error)
          this.escolaOptions = []
        }
      }
    },
    formatarNomeTurma(c) {
      if (!c) return ''
      const turma = (c.turma || '').trim()
      const ano = (c.ano || '').trim()
      const turno = (c.turno || '').trim()

      if (/ano|º|ª/i.test(turma)) {
        return turno ? `${turma} - ${turno}` : turma
      }

      if (/ano|º|ª/i.test(ano)) {
        const nome = turma ? `${ano} ${turma}` : ano
        return turno ? `${nome} - ${turno}` : nome
      }

      if (/^\d+$/.test(ano)) {
        const nome = turma ? `${ano}º ano ${turma}` : `${ano}º ano`
        return turno ? `${nome} - ${turno}` : nome
      }

      const partes = [ano, turma].filter(Boolean).join(' ')
      return turno ? `${partes} - ${turno}` : partes
    },
    async carregarTurmas(schoolId) {
      this.turmaOptions = []
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      const isProfessor = userData?.role === 'Professor' || userData?.role === 3

      if (isProfessor && this.professorTurmas && this.professorTurmas.length) {
        const filtradas = schoolId
          ? this.professorTurmas.filter(t => (t.escolaId || t.schoolId) === schoolId)
          : this.professorTurmas
        this.turmaOptions = filtradas.map(t => ({
          value: t.id || t.turmaId,
          text: this.formatarNomeTurma(t) || t.turma || t.name,
        }))
      } else if (schoolId) {
        try {
          const res = await classroomService.getAll({ schoolId, page: 1, itemsPerPage: 1000 })
          const list = res.content || res || []
          this.turmaOptions = list.map(c => ({
            value: c.id,
            text: this.formatarNomeTurma(c),
          }))
        } catch (error) {
          console.error('Erro ao carregar turmas:', error)
        }
      }
    },
    async onEscolaChange(val) {
      this.filtro.classroomId = null
      await this.carregarTurmas(val)
      this.filtro.page = 1
      this.fetchQuestionarios()
    },
    onSearchInput() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.filtro.page = 1
        this.fetchQuestionarios()
      }, 400)
    },
    limparFiltros() {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      const isProfessor = userData?.role === 'Professor' || userData?.role === 3
      this.filtro = {
        search: '',
        schoolId: null,
        classroomId: null,
        professorId: (isProfessor && userData?.id) ? userData.id : null,
        page: 1,
        itemsPerPage: 10,
      }
      this.turmaOptions = []
      this.fetchQuestionarios()
    },
    async fetchQuestionarios() {
      showSpinner()
      try {
        const res = await questionarioSocioService.getAll(this.filtro)
        this.fetchedData = res || { content: [], totalItems: 0, totalPages: 0, currentPage: 1 }
      } catch (e) {
        console.error('Erro ao buscar questionários', e)
      } finally {
        hideSpinner()
      }
    },
    formatarData(dt) {
      if (!dt) return '-'
      return moment(dt).format('DD/MM/YYYY HH:mm')
    },
    async abrirDetalhes(id) {
      this.modalDetalhesAberto = true
      this.isLoadingDetalhes = true
      this.detalhes = null
      try {
        const item = await questionarioSocioService.getById(id)
        this.detalhes = item
      } catch (e) {
        console.error('Erro ao carregar detalhes do questionário', e)
      } finally {
        this.isLoadingDetalhes = false
      }
    },
    exportarCsv() {
      if (!this.fetchedData.content || !this.fetchedData.content.length) return

      const headers = [
        'Nome Completo',
        'Escola',
        'Turma',
        'Turno',
        'E-mail',
        'Telefone',
        'Responsável',
        'Parentesco',
        'Tel. Responsável',
        'Bairro',
        'Cidade',
        'CEP',
        'Teve Dengue',
        'Teve Chikungunya',
        'Teve Zika',
        'Data Resposta',
      ]

      const rows = this.fetchedData.content.map(i => [
        `"${(i.nomeCompleto || '').replace(/"/g, '""')}"`,
        `"${(i.escola || '').replace(/"/g, '""')}"`,
        `"${(i.turma || '').replace(/"/g, '""')}"`,
        `"${(i.turno || '').replace(/"/g, '""')}"`,
        `"${(i.email || '').replace(/"/g, '""')}"`,
        `"${(i.telefone || '').replace(/"/g, '""')}"`,
        `"${(i.nomeResponsavel || '').replace(/"/g, '""')}"`,
        `"${(i.grauParentesco || '').replace(/"/g, '""')}"`,
        `"${(i.telefoneResponsavel || '').replace(/"/g, '""')}"`,
        `"${(i.bairro || '').replace(/"/g, '""')}"`,
        `"${(i.cidade || '').replace(/"/g, '""')}"`,
        `"${(i.cep || '').replace(/"/g, '""')}"`,
        `"${(i.teveDengue || '').replace(/"/g, '""')}"`,
        `"${(i.teveChikungunya || '').replace(/"/g, '""')}"`,
        `"${(i.teveZikaVirus || '').replace(/"/g, '""')}"`,
        `"${this.formatarData(i.createdAt)}"`,
      ])

      const csvContent = '\uFEFF' + [headers.join(';'), ...rows.map(r => r.join(';'))].join('\r\n')
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', `questionarios_sociodemograficos_${moment().format('YYYYMMDD_HHmm')}.csv`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
</script>

<style lang="scss" scoped>
.header-marcar_consulta {
  border-radius: 0.5rem;
}
</style>
